import { ROUTES } from "../constants/routes";

export const function_expenses = ({ detail, location }) => {
    if (detail?.features?.expense_report?.activated ?? true) {
        return {
            activated: true,
            navigate: false,
            to: null,
            state: null,
        };
    } else {
        return {
            activated: false,
            navigate: true,
            to: ROUTES.denied,
            state: { path: location.pathname },
        };
    }
};

export const function_telework = ({ detail, location }) => {
    if (detail?.features?.telework?.activated) {
        return {
            activated: true,
            navigate: false,
            to: null,
            state: null,
        };
    } else {
        return {
            activated: false,
            navigate: true,
            to: ROUTES.denied,
            state: { path: location.pathname },
        };
    }
};

export const function_timereporting = ({ detail, location }) => {
    if (
        location.pathname.includes("time_reporting") &&
        !detail?.features?.time_reporting?.display_in_main_menu
    ) {
        return {
            activated: false,
            navigate: true,
            to: ROUTES.denied,
            state: { path: location.pathname },
        };
    }

    if (
        location.pathname === "/time_reporting" &&
        !detail?.features?.time_reporting?.activated_for_me &&
        detail?.features?.time_reporting?.activated_for_me_as_manager
    ) {
        return {
            activated: false,
            navigate: true,
            to: ROUTES.time_reporting.team_tracking,
            state: { path: location.pathname },
        };
    }

    return {
        activated: true,
        navigate: false,
    };
};
